import dayjs from "dayjs";

const getProponentsData = (data) => {
  return data.map((proponent) => ({
    name: proponent.name,
    country_code: proponent.mobile_no.country_code.substring(1),
    phone_number: proponent.mobile_no.phone_number,
    email: proponent.email,
  }));
};

const getValidationBody = (
  validationBodyData,
  verificationBodies,
  registries
) => {
  return validationBodyData.map((validationData) => ({
    organisation_name: getIdByLabel(
      verificationBodies,
      validationData.organisation_name
    ),
    name: validationData.validator_details.name,
    country_code:
      validationData.validator_details.mobile_no.country_code.substring(1),
    phone_number: validationData.validator_details.mobile_no.phone_number,
    email: validationData.validator_details.email,
    authorized_registry_name: getIdByLabel(
      registries,
      validationData.authorized_registry_name
    ),
    address_line: validationData.validator_details.address_details.address_line,
    city: validationData.validator_details.address_details.city,
    country: validationData.validator_details.address_details.country_code,
  }));
};

const getVeriferBody = (
  varificationBodyData,
  verificationBodies,
  registries
) => {
  return varificationBodyData.map((varificationData) => ({
    organisation_name: getIdByLabel(
      verificationBodies,
      varificationData.organisation_name
    ),
    name: varificationData.verifier_details.name,
    country_code:
      varificationData.verifier_details.mobile_no.country_code.substring(1),
    phone_number: varificationData.verifier_details.mobile_no.phone_number,
    email: varificationData.verifier_details.email,
    authorized_registry_name: getIdByLabel(
      registries,
      varificationData.authorized_registry_name
    ),
    address_line:
      varificationData.verifier_details.address_details.address_line,
    city: varificationData.verifier_details.address_details.city,
    country: varificationData.verifier_details.address_details.country_code,
  }));
};

const getIdByLabel = (verificationBodies, name) => {
  for (var i = 0; i < verificationBodies.length; i++) {
    if (verificationBodies[i].label === name) {
      return verificationBodies[i].value;
    }
  }
  return null;
};

export const populateData = (
  projectDetails,
  form,
  verificationBodies,
  registries
) => {
  const startDate = dayjs(projectDetails.project_dates.start_date);
  const projectRegistrationDate = dayjs(
    projectDetails.project_registration_date
  );
  // console.log("Other Registry",projectDetails.others_registry_name)
  // console.log("Registry",projectDetails.registry_name)
  const projectIssuanceDate = dayjs(projectDetails.project_issuance_date);
  const endDate = dayjs(projectDetails.project_dates.end_date);

  form.setFieldsValue({
    others_registry_name: projectDetails.others_registry_name || '',
    about_project: projectDetails.about_project,
    project_impact_and_benefits: projectDetails.project_impact_and_benefits,
    registry_name: projectDetails.registry_name._id,
    project_name: projectDetails.project_name,
    project_id: projectDetails.project_id,
    proponents_details: getProponentsData(projectDetails.proponents_details),
    project_developer_details: getProponentsData(
      projectDetails.project_developer_details
    ),
    projectStillGoingOn: projectDetails.projectStillGoingOn,
    crediting_period: projectDetails.crediting_period,
    project_scale: projectDetails.project_scale,
    no_of_credits_on_registry: projectDetails.no_of_credits_on_registry,
    no_of_credits_on_offsetGo_marketPlace:
      projectDetails.no_of_credits_on_offsetGo_marketPlace,
    type_of_credit: projectDetails.type_of_credit,
    // others_registry_name : projectDetails.others_registry_name,
    start_date: startDate,
    end_date: endDate,
    project_registration_date: projectRegistrationDate,
    project_issuance_date: projectIssuanceDate,

    validation_body: getValidationBody(
      projectDetails.validation_body,
      verificationBodies,
      registries
    ),
    verifier_body: getVeriferBody(
      projectDetails.verifier_body,
      verificationBodies,
      registries
    ),
  });
};

const getFileName = (imageUrl) => {
  if (imageUrl) {
    return imageUrl.split("/").pop(); // Only perform split if imageUrl is defined
  }
  return ""; // Return an empty string if imageUrl is undefined
};

// const getFileName = (url) => {
//   const arr = url.split("/");
//   return arr[arr.length - 1];
// };

// export const populateDocs = (docs) => {
//   const newState = {};

//   for (let key in docs) {
//     if (key === "project_images") {
//       newState[key] = [
//         { name: getFileName(docs[key][0]), url: docs[key][0], status: "done" },
//         { name: getFileName(docs[key][1]), url: docs[key][1], status: "done" },
//         { name: getFileName(docs[key][2]), url: docs[key][2], status: "done" },
//         { name: getFileName(docs[key][3]), url: docs[key][3], status: "done" },
//       ];
//     } else {
//       newState[key] = [
//         { name: getFileName(docs[key]), url: docs[key], status: "done" },
//       ];
//     }
//   }
//   return newState;
// };


export const populateDocs = (docs) => {
  const newState = {};

  for (let key in docs) {
    if (key === "project_images") {
      newState[key] = docs[key]
        .filter((imageUrl) => imageUrl)
        .map((imageUrl) => ({
          name: getFileName(imageUrl),
          url: imageUrl,
          status: "done",
        }));
    } else {
      if (docs[key]) {
        newState[key] = [
          { name: getFileName(docs[key]), url: docs[key], status: "done" },
        ];
      }
    }
  }
  return newState;
};
